import axiosInstance from './axiosInstance';
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const validateM11Report = async (apiToken = null, stepCount = null, m11ResearchStudyFoi = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!stepCount) {
        console.log("no stepCount");
        return null;
    }
    if (!m11ResearchStudyFoi) {
        console.log("no m11ResearchStudyFoi");
        return null;
    }
    let body = {
        'functionid': 'validatem11report',
        'apiToken': apiToken,
        'stepCount': stepCount,
        'm11ResearchStudyFoi': m11ResearchStudyFoi
    };
    console.log("CALLING SERVER with validatem11report");
    return await axiosInstance({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: body,
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from validatem11report call");
    }).catch((error) => { console.log(error); });
};

const validateStep = async (apiToken, stepCount, m11ResearchStudyFoi,
  setValidationCheckState) => {

  let response = await validateM11Report(apiToken, stepCount, m11ResearchStudyFoi);
  if (response?.success) {
    setValidationCheckState(JSON.parse(JSON.stringify(response)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

export default validateM11Report;
export { validateStep };